import { render, staticRenderFns } from "./ProjectPaymentPlanDistribution.vue?vue&type=template&id=5ffbbe34"
import script from "./ProjectPaymentPlanDistribution.vue?vue&type=script&lang=js"
export * from "./ProjectPaymentPlanDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports